// extracted by mini-css-extract-plugin
module.exports = {"container":"text-mock-screen_container__lxyXk"};